import React, { FC, useEffect, useState } from 'react';
import AEAGrid from '../../../ui/aea-grid/aea-grid';
import { MainBudgetPresenter } from '@presenters/screens/main-budget.presenter';
import { IMainBudget } from '@interfaces/screens/main-budget.interface';

const IndexBudget: FC<any> = () => {
    const [dataColumns, setDataColumns] = useState(null);
    const [dataSource, setDataSource] = useState([]);

    const view: IMainBudget = { state: {
        dataSource,
        dataColumns,
        setDataColumns,
        setDataSource
     } };
    const presenter = new MainBudgetPresenter(view);

    useEffect(() => {
        presenter.initializeIndex();
    }, []);

    useEffect(() => {
        if(presenter.params && Object.keys(presenter?.params)?.length && presenter.formMaster) presenter.getIndexDataSource();
    }, [presenter.params, presenter.formMaster]);

    return (
        <div>          
            <AEAGrid
                {...presenter.dsProps}>
            </AEAGrid>
        </div>
    )
}

export default IndexBudget;
